export default {
  account_id_required: "계정 ID를 입력해 주세요.",
  account_not_exists: "비밀번호가 올바르지 않습니다.",
  accountIdRequired: "세션이 만료되었습니다! 계속하려면 다시 로그인해 주세요...",
  agent_comm_rate_required: "에이전트 커미션율을 입력해 주세요.",
  agent_id_required: "에이전트 ID를 입력해 주세요.",
  alphaNumOnly: "영문과 숫자만 입력할 수 있습니다",
  atLeastThreeMatchToBetParlay: "조합 베팅에는 최소 3경기를 선택해야 합니다.",
  atLeastTwoMatchToBetParlay: "조합 베팅에는 최소 2경기를 선택해야 합니다.",
  bet_amount_required: "베팅 금액을 입력해 주세요.",
  bet_id_required: "베팅 ID를 입력해 주세요.",
  betAmountRequired: "베팅 금액을 입력해 주세요.",
  betExists: "이미 등록된 베팅입니다.",
  betLowerMin: "베팅 금액이 최소 한도보다 적습니다.",
  betNotExists: "토너먼트에 참가하려면 유효한 베팅을 진행해 주세요.",
  betOverMax: "베팅 금액이 최대 한도를 초과했습니다.",
  betOverMaxBet: "베팅 금액이 최대 한도를 초과했습니다.",
  betOverMaxPerMatch: "베팅 금액이 최대 한도를 초과했습니다.",
  betTypeRequired: "베팅 유형을 선택해 주세요.",
  BLOCK: "계정이 차단되었습니다!",
  changeStakeMax: "최대 한도에 따라 입력한 베팅 금액이 변경되었습니다.",
  changeStakeMin: "최소 한도에 따라 입력한 베팅 금액이 변경되었습니다.",
  CLOSE: "계정이 폐쇄되었습니다!",
  close: "폐쇄된 계정입니다! 계속하려면 상위 에이전트에게 문의해 주세요...",
  confirmNewPasswordRequired: "새 비밀번호 확인을 입력해 주세요!",
  connectionFailed: "지갑 시스템 연결에 실패했습니다.",
  containAlphaNum: "{fname}에는 영문자와 숫자가 각각 하나 이상 포함되어야 합니다.",
  "createRoomFailed-1": "룸 생성에 실패했습니다. (1)",
  "createRoomFailed-2": "룸 생성에 실패했습니다. (2)",
  "createRoomFailed-3": "룸 생성에 실패했습니다. (3)",
  credit_amount_required: "입금액을 입력해 주세요.",
  currency_required: "통화를 선택해 주세요.",
  currencyNotSupported: "지원하지 않는 통화입니다",
  currPasswordRequired: "현재 비밀번호를 입력해 주세요!",
  dataError: "데이터 오류",
  debit_amount_required: "출금액을 입력해 주세요.",
  duplicate_credit_record: "중복 입금 기록입니다.",
  duplicate_debit_record: "배당률을 업데이트 중입니다. 잠시만 기다려 주세요...",
  endDateRequired: "종료일을 입력해 주세요!",
  EsportsDisabled: "e스포츠 게임이 비활성화되었습니다",
  forbiddenAccess: "접근이 금지되었습니다",
  FREEZE: "계정이 동결되었습니다!",
  freeze: "동결된 계정입니다! 계속하려면 상위 에이전트에게 문의해 주세요...",
  game_maintenance: "게임을 점검 중입니다.",
  incompletedRequest: "문제가 발생했습니다...",
  insufficient_balance: "잔액이 부족합니다",
  invalid_password: "비밀번호가 올바르지 않습니다.",
  invalidBetAmount: "베팅 금액이 올바르지 않습니다.",
  invalidBets: "이 베팅 마켓은 이용할 수 없습니다. 다른 마켓을 선택해 주세요.",
  invalidCurrency: "베팅에 사용할 수 없는 통화입니다.",
  invalidleague: "리그 정보가 올바르지 않습니다.",
  invalidMarketType: "마켓 유형이 올바르지 않습니다.",
  invalidMatch: "경기 정보가 올바르지 않습니다.",
  invalidMember: "회원 정보가 올바르지 않습니다.",
  invalidOddsBall: "배당률을 업데이트 중입니다. 잠시만 기다려 주세요...",
  invalidOperator: "운영사 정보가 올바르지 않습니다.",
  invalidPassword: "비밀번호가 올바르지 않습니다",
  invalidRoom: "룸 정보가 올바르지 않습니다.",
  invalidRoomLimit: "룸 인원 제한이 올바르지 않습니다.",
  invalidRoomPassword: "PIN 코드가 올바르지 않습니다. PIN 코드는 숫자 6자리여야 합니다.",
  invalidRoomRate: "룸 참가비가 올바르지 않습니다.",
  invalidRoomType: "룸 유형이 올바르지 않습니다.",
  invalidRTSMatchOdds: "경기 배당률이 올바르지 않습니다. (RTS)",
  invalidSession: "세션이 올바르지 않거나 만료되었습니다.",
  IPJoinedBefore: "이미 참가한 IP입니다.",
  isAlpha: "{fname}에는 영문자만 입력할 수 있습니다.",
  isAlphaNum: "{fname}에는 영문과 숫자만 입력할 수 있습니다.",
  isEmail: "{fname}에 올바른 이메일 주소를 입력해 주세요.",
  isIpAddress: "{fname}에 올바른 IPv4 주소를 입력해 주세요.",
  isMaxLength: "{fname}은(는) {fvalue}자 이하여야 합니다.",
  isMaxValue: "{fname}은(는) {fvalue} 이하여야 합니다.",
  isMinLength: "{fname}은(는) 최소 {fvalue}자 이상이어야 합니다.",
  isMinValue: "{fname}은(는) 최소 {fvalue} 이상이어야 합니다.",
  isNumeric: "{fname}에는 숫자만 입력할 수 있습니다.",
  isOutrightRequired: "아웃라이트 여부를 선택해 주세요!",

  // vuelidate
  isRequired: "{fname}을(를) 입력해 주세요.",
  isSameAs: "{fname}은(는) {fname2}와(과) 일치해야 합니다.",
  isUrl: "{fname}에 올바른 URL을 입력해 주세요.",
  "joinFailed-1": "룸 입장에 실패했습니다. (1)",
  "joinFailed-2": "룸 입장에 실패했습니다. (2)",
  leagueIdRequired: "리그 ID를 입력해 주세요!",
  liveCasinoDisabled: "라이브 카지노가 비활성화되었습니다",
  liveMatchNotAllowed: "라이브 경기는 허용되지 않습니다.",

  //tournament
  login_id_not_exists: "로그인 정보가 올바르지 않습니다. 다시 로그인해 주세요.",
  loginFailed: "로그인에 실패했습니다. 잠시 후 다시 시도해 주세요...",
  loginLimit: "로그인 시도가 너무 잦습니다. 1분 후 다시 시도해 주세요...",
  lotteryDisabled: "로또가 비활성화되었습니다",
  marketTypeChanged: "마켓 유형이 변경되어 베팅 슬립에서 삭제되었습니다.<br />마켓에서 다시 선택해 주세요.",
  marketTypeRequired: "마켓 유형을 선택해 주세요.",
  master_comm_rate_required: "마스터 커미션율을 입력해 주세요.",
  master_id_required: "마스터 ID를 입력해 주세요.",
  matchDateRequired: "경기 날짜를 입력해 주세요.",
  matchHide: "이 베팅 마켓은 이용할 수 없습니다. 다른 마켓을 선택해 주세요.",
  matchLowerMin: "선택한 경기 수가 최소 기준보다 적습니다.",
  matchNotActive: "이 경기는 이용할 수 없습니다. 다른 경기 마켓을 선택해 주세요.",
  matchNotAllowBet: "이 베팅 마켓은 이용할 수 없습니다. 다른 마켓을 선택해 주세요.",
  matchOverMax: "선택한 경기 수가 최대 기준을 초과했습니다.",
  matchRequired: "경기를 선택해 주세요.",
  maxMatch: "최대 {max}경기까지 선택할 수 있습니다!",
  maxParlayTicket: "조합 베팅의 최대 베팅 수에 도달했습니다!",
  maxRoomLimit: "참가 인원은 30명 이하여야 합니다.",
  maxRoomRate: "참가비는 1000 이하여야 합니다.",
  member_id_required: "회원 ID를 입력해 주세요.",
  member_wallet_not_exists: "회원 지갑이 존재하지 않습니다.",
  memberExists: "이미 존재하는 회원입니다.",
  memberJoinedBefore: "이미 참가한 기록이 있습니다. 공개 무료 룸에는 한 번만 참가할 수 있습니다.",
  minBetAmount: "베팅 금액이 최소 기준보다 적습니다.",
  MiniGameDisabled: "미니게임이 비활성화되었습니다",
  minMatch: "최소 3경기를 선택해야 합니다.",
  minRoomLimit: "참가 인원은 3명 이상이어야 합니다.",
  minRoomRate: "참가비는 10 이상이어야 합니다.",
  new_login_id_exists: "사용할 수 없는 닉네임입니다. 다른 닉네임을 입력해 주세요.",
  newPasswordRequired: "새 비밀번호를 입력해 주세요!",
  nickNameRequired: "닉네임을 입력해 주세요!",
  noMatchSelected: "경기를 1개 이상 선택해 주세요.",
  notSameAs: "{fname}과(와) {fname2}은(는) 같을 수 없습니다.",
  NoUserAccessRight: "접근 권한이 없습니다! 계속하려면 상위 에이전트에게 문의해 주세요...",
  oddsDisplayInvalid: "배당률을 업데이트 중입니다. 잠시만 기다려 주세요...",
  oddsIsUpdating: "배당률을 업데이트 중입니다...",
  OK: "확인",
  pageNumberRequired: "페이지 번호를 입력해 주세요!",
  pageSizeRequired: "페이지 크기를 입력해 주세요!",
  passwordRequired: "비밀번호를 입력해 주세요!",
  passwordsNotMatch: "비밀번호가 일치하지 않습니다!",
  permission_denied: "권한이 없습니다.",
  pointsOverLimit: "포인트가 한도를 초과했습니다.",
  rate_required: "비율을 입력해 주세요.",
  rateLowerMin: "비율이 최소 기준보다 낮습니다.",
  rateOverMax: "비율이 최대 기준을 초과했습니다.",
  requestFailed: "연결이 불안정합니다. 네트워크 상태를 확인한 후 다시 시도해 주세요.",
  requestLimit: "요청이 너무 잦습니다.",
  requestPending: "요청을 처리 중입니다...",
  result_exists: "이미 결과가 등록되었습니다.",
  room_id_required: "룸 ID를 입력해 주세요.",
  roomClosed: "룸이 폐쇄되었습니다.",
  roomClosedNotAllowed: "폐쇄된 룸에서는 이용할 수 없습니다.",
  roomEnded: "이미 종료된 룸입니다.",
  roomEndedOrCancelled: "룸이 종료되었거나 취소되었습니다.",
  roomExists: "비공개 룸은 1개를 초과하여 생성할 수 없습니다.",
  RoomExists: "비공개 룸은 1개를 초과하여 생성할 수 없습니다.",
  roomFull: "룸 정원이 가득 찼습니다.",
  roomIdRequired: "룸 ID를 입력해 주세요.",
  roomIsPublicFree: "공개 무료 룸입니다.",
  roomLimitLowerMin: "룸 인원 제한이 최소 기준보다 낮습니다.",
  roomLimitOverMax: "룸 인원 제한이 최대 한도를 초과했습니다.",
  roomLimitRequired: "룸 인원 제한을 입력해 주세요.",
  roomNotExists: "존재하지 않는 룸입니다.",
  roomOverMax: "룸 수가 최대 한도를 초과했습니다.",
  roomPasswordRequired: "PIN 코드를 입력해 주세요.",
  roomRateRequired: "룸 참가비를 입력해 주세요.",
  roomTypeRequired: "룸 유형을 선택해 주세요.",
  s_senior_comm_rate_required: "슈퍼 시니어 커미션율을 입력해 주세요.",
  s_senior_id_required: "슈퍼 시니어 ID를 입력해 주세요.",
  secondary_account_exists: "이미 생성된 닉네임입니다.",
  selectLeague: "리그를 1개 이상 선택해 주세요.",
  selectOption: "{fname}을(를) 선택해 주세요.",
  senior_comm_rate_required: "시니어 커미션율을 입력해 주세요.",
  senior_id_required: "시니어 ID를 입력해 주세요.",
  session_expired: "세션이 만료되었습니다! 계속하려면 다시 로그인해 주세요...",
  session_not_exists: "세션이 만료되었습니다! 계속하려면 다시 로그인해 주세요...",
  sessionTokenRequired: "세션 토큰을 입력해 주세요.",
  shareholder_comm_rate_required: "주주 커미션율을 입력해 주세요.",
  shareholder_id_required: "주주 ID를 입력해 주세요.",
  slotDisabled: "슬롯이 비활성화되었습니다",
  sportsTypeRequired: "스포츠 종목을 선택해 주세요!",
  startDateRequired: "시작일을 입력해 주세요!",
  SUSPEND: "계정이 조회 전용으로 변경되었습니다.",
  suspend: "정지된 계정입니다! 계속하려면 상위 에이전트에게 문의해 주세요...",
  systemError: "내부 시스템 오류가 발생했습니다.",
  tournamentDisabled: "토너먼트가 비활성화되었습니다. 상위 에이전트에게 문의해 주세요.",
  tournamentLeagueExists: "이미 등록된 토너먼트 리그입니다.",
  tournamentMatchExists: "이미 등록된 토너먼트 경기입니다.",
  transfer_id_required: "이체 ID를 입력해 주세요.",
  unableToGetBalanceAtTheMoment: "내부 서버 오류가 발생했습니다.",
  usernameRequired: "사용자 이름을 입력해 주세요!",
  workingDateRequired: "작업일을 입력해 주세요!",
  matchNotStarted: "경기가 아직 시작되지 않았습니다.",
  cashOutUnavailable: "캐시아웃을 이용할 수 없습니다.",
  errorCashoutAmount: "캐시아웃 정보를 업데이트 중입니다...",
  invalidParameter: "입력한 매개변수가 올바르지 않습니다.",
  startTimeRequired: "시작 시간을 입력해 주세요.",
  endTimeRequired: "종료 시간을 입력해 주세요.",
  oddsTypeIDRequired: "배당 유형을 선택해 주세요.",
  commissionRequired: "커미션을 입력해 주세요.",
  requestTimeRequired: "요청 시간을 입력해 주세요.",
  statusRequired: "상태를 선택해 주세요.",
  invalidStartTime: "시작 시간이 올바르지 않습니다.",
  invalidEndTime: "종료 시간이 올바르지 않습니다.",
  invalidOddsTypeID: "배당 유형이 올바르지 않습니다.",
  invalidCommission: "커미션이 올바르지 않습니다.",
  invalidRequestTime: "요청 시간이 올바르지 않습니다.",
  invalidStatus: "상태가 올바르지 않습니다",
  invalidAlgoMatchInfo: "이 베팅 마켓은 마감되었습니다. 다른 마켓을 선택해 주세요. (-101)",
  invalidAlgoSliderLeagueInfo: "리그 정보가 올바르지 않습니다.",
  invalidAlgoSliderMinutesWeight: "분 단위 가중치가 올바르지 않습니다.",
  invalidAlgoSliderBetType: "베팅 유형이 올바르지 않습니다.",
  invalidRTSRunningScoreDetails: "진행 점수 상세 정보가 올바르지 않습니다. (RTS)",
  invalidProviderGoalTimeLine: "제공사의 골 타임라인이 올바르지 않습니다.",
  invalidSliderTimeRange: "시간 범위가 올바르지 않습니다.",
  invalidMOMatchOdds: "경기 배당률을 업데이트 중입니다...",
  invalidProviderSlider: "TM 정보가 올바르지 않습니다.",
  invalidCombineBetTypeAndOddsFormat: "베팅 유형과 배당 표기 방식의 조합이 올바르지 않습니다.",
  invalidMatchInformation: "경기 정보가 올바르지 않습니다.",
  marketClose: "이 베팅 마켓은 마감되었습니다. 다른 마켓을 선택해 주세요.",
  error: "오류",
  freeRoomNeedBet: "무료 룸 이용 권한을 받으려면 조건을 충족하는 베팅을 먼저 진행해 주세요.",
};